import { Image, Link, Page, View } from "@react-pdf/renderer"
import { colors } from "../../../src/config/theme"
import staticPath from "../../config/staticPath"
import Separator from "./Separator"
import Text from "./Text"

const FrontPage = ({ title }: { title: string }) => (
  <Page size="A4" wrap>
    <View
      style={{
        backgroundColor: colors.primary,
        height: "100%",
        padding: 30,
        display: "flex",
      }}
    >
      <Image
        cache={false}
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          top: 30,
          left: 30,
        }}
        src={{
          uri: staticPath("/images/background.png"),
          method: "GET",
          headers: {},
          body: "",
        }}
      />
      <View
        style={{
          paddingTop: 50,
          paddingHorizontal: 50,
          paddingBottom: 94,
          display: "flex",
          width: "100%",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
      >
        <Image
          cache={false}
          style={{
            height: 40,
            width: 104,
          }}
          src={{
            uri: staticPath("/images/logo.png"),
            method: "GET",
            headers: {},
            body: "",
          }}
        />
      </View>
      <View
        style={{
          paddingHorizontal: 48,
          flex: 1,
        }}
      >
        <Separator color={colors.white} />
        <Text
          style={{
            fontSize: 38,
            color: "#ffffff",
            fontWeight: "bold",
          }}
        >
          {title}
        </Text>
      </View>
      <View
        style={{
          flex: 0,
          paddingHorizontal: 34,
          paddingBottom: 18,
        }}
      >
        <Link src="https://www.belimo.com/contact" wrap>
          <Text
            style={{
              fontSize: 20,
              lineHeight: 20,
              textAlign: "right",
              color: "#ffffff",
              fontWeight: "bold",
            }}
          >
            belimo.com/contact
          </Text>
        </Link>
      </View>
    </View>
  </Page>
)

export default FrontPage
